import Order from "./Order/Order";
import Delivery from "./Delivery/index";
import Payment from "./Payment/index";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { UserActions } from "../store/user";
import { EMenuActions } from "../store";
import { useLocation, useNavigate } from "react-router-dom";
import Button from "../components/button";
import { faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios";
import { toast } from "react-toastify";

export default function Index() {
  let dispatch = useDispatch();
  const waiterScreen = useLocation().pathname.split("/")[2];
  const waiter = JSON.parse(localStorage.getItem("waiterId"));
  const [wId, setWID] = useState();
  const [loading, setLoading] = useState();
  const [wIdreq, setWIdreq] = useState(false);

  const userExist = useSelector((state) => state.User.userExist);
  const c_url = useSelector((state) => state.Company.c_url);
  const auth_token = useSelector((state) => state.Company.auth_token);
  const lclUser = JSON.parse(localStorage.getItem("user"));
  const cartItems = useSelector((state) => state.EMenu.cartItems);

  useEffect(() => {
    dispatch(EMenuActions.setPlaceOrder(false));
    if (lclUser != null) {
      dispatch(UserActions.setUserExist(userExist));
      dispatch(UserActions.setUserName(lclUser[0].userName));
      dispatch(UserActions.setUserPhone(lclUser[0].userPhone));
      dispatch(UserActions.setUserAddress(lclUser[0].userAddress));
      dispatch(EMenuActions.setDeliveryMethod("outdoor"));
    } else if (lclUser === null) {
      dispatch(UserActions.setUserExist(!userExist));
      dispatch(EMenuActions.setDeliveryMethod("indoor"));
    }
  }, []);

  const handleVerify = async () => {
    setLoading(true);
    axios
      .post(
        `https://${c_url}/api/v1/ValidateWaiterCode`,
        { waiterCode: wId },
        {
          headers: { Authorization: `${auth_token}` },
        }
      )
      .then((res) => {
        if (res.data.waiterInfo.length !== 0) {
          localStorage.setItem("waiterId", JSON.stringify(res.data.waiterInfo));
          setWIdreq(!wIdreq);
          setLoading(false);
        }
      })
      .catch((err) => {
        setLoading(false);
        toast.error("Not a valid waiter ", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      });
  };
  return (
    <div className="h-[100vh] max-w-full overflow-y-scroll">
      {waiterScreen === "waiterscreen" && !wIdreq && (
        <div className="absolute bg-dark/20 h-full w-full backdrop-blur-sm flex items-center place-content-center">
          <div className="bg-white w-[90%] lg:w-[30%] p-8 rounded-lg">
            <label className="text-sm font-extrabold tracking-tighter">
              Enter your User ID
            </label>
            <input
              value={wId}
              type="password"
              name="name"
              onChange={(e) => setWID(e.target.value)}
              className={`w-[100%] mt-2 mb-2 max-sm:mb-5 border border-dark/30 rounded-md py-2 px-3 outline-none`}
            />
            <Button
              title={`${loading ? "Verifying please hold on..." : "Verify"}`}
              type={"bgBtn"}
              bgColor={`bg-dark`}
              textColor={"text-white"}
              onClick={handleVerify}
            />
          </div>
        </div>
      )}
      <div className="font-black text-2xl bg-secondary max-sm:text-xl uppercase p-4 text-white">
        <p className="w-[94%] m-auto">Check Out</p>
      </div>
      <div className="w-[100%] m-auto lg:flex gap-7 my-auto rounded-md place-self-center">
        <div className="md:w-[60%] md:p-16 max-md:p-5">
          {cartItems?.length === 0 ? (
            <div className="w-[50%] m-auto text-center">
              <FontAwesomeIcon
                className="text-dark/10 text-7xl mb-2"
                icon={faTriangleExclamation}
              />
              <p className="text-md mb-3">Please go back to the home page</p>
              <Button
                type={"bgBtn"}
                title={"Back to Home"}
                onClick={handleVerify}
              />
            </div>
          ) : (
            <>
              <Order />
              <Delivery />
            </>
          )}
        </div>

        <div className="md:w-[40%] h-[100vh] bg-primaryLight/50 p-10">
          <Payment />
        </div>
      </div>
    </div>
  );
}
